export default __webpack_public_path__ + "static/media/no-avatar.bb3e718e.svg";